// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/square.js';

import { paths } from '../generated/square';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('square', Original, paths);
